import React from 'react';
import './styles/mdlz-newsletter.scss';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import DefaultTrans from '../../default-i18next-trans';
import EmailTrans from '../../email-i18next-trans';

const { REACT_APP_STATIC_PREFIX = '/static' } = import.meta.env;

function MDLZnewsletter({
    ui,

    handleLinkClick,
    handleLinkMouseLeave,
    handleLinkMouseEnter,
}) {
    const { t } = useTranslation('assessment');
    const { link } = ui;

    return (
        <div className="email-text mdlz-newsletter">
            <div className="mdlz-email-header">
                <img
                    src={`${REACT_APP_STATIC_PREFIX}/img/assessment/email-header-mdlz.png`}
                    alt={t('Need to do')}
                />
            </div>
            <div className="body">
                <EmailTrans
                    link={link}
                    linkFunctionality={{
                        handleLinkClick,
                        handleLinkMouseLeave,
                        handleLinkMouseEnter,
                    }}
                    translatedString={t(ui.email.text)}
                />
            </div>
            <Row>
                <Col md="4" xs="12">
                    <div className="img">
                        <img
                            src={`${REACT_APP_STATIC_PREFIX}/img/assessment/email-windows10-logo.png`}
                            alt={t('Windows 10')}
                        />
                    </div>
                </Col>
                <Col md="8" xs="12">
                    <div className="blue">
                        <strong>{t('Important pre-upgrade tasks')}</strong>
                        <ul>
                            <li>
                                <DefaultTrans
                                    translatedString={t(
                                        'Start now by making time for the upgrade'
                                    )}
                                />
                            </li>
                            <li>
                                <DefaultTrans
                                    translatedString={t(
                                        'Move your files to OneDrive for Business'
                                    )}
                                />
                            </li>
                            <li>
                                <DefaultTrans
                                    translatedString={t(
                                        'Restart your PC before the upgrade'
                                    )}
                                />
                            </li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default observer(MDLZnewsletter);
